import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=49a54cbe&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=ts"
export * from "./NotificationBar.vue?vue&type=script&lang=ts"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=49a54cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a54cbe",
  null
  
)

export default component.exports